<template>
    <div ref="chart" class="chart-container"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
    name: "LineChart",
    props: {
        // 数据源（可传入，不传就用默认随机数据）
        chartData: {
            type: Array,
            default: () => []
        },
        colorS: {
            type: String,
            default: '#ff4834'
        }
    },
    data() {
        return {
            chart: null
        };
    },
    mounted() {
        this.initChart();
        window.addEventListener("resize", this.resizeChart);
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
        window.removeEventListener("resize", this.resizeChart);
    },
    methods: {
        initChart() {
            if (!this.chart) {
                this.chart = echarts.init(this.$refs.chart);
            }
            // console.log(this.chartData, '111');
            const _data = this.chartData
            const option = {
                grid: { top: 0, bottom: 0, left: 0, right: 0 },
                xAxis: {
                    type: "time",
                    axisLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: { show: false },
                    splitLine: { show: false },
                    boundaryGap: false
                },
                yAxis: {
                    min: "dataMin",
                    axisLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: { show: false },
                    splitLine: { show: false },
                    boundaryGap: false
                },
                dataZoom: [
                    {
                        type: "inside",
                        zoomOnMouseWheel: false, // 禁止滚轮缩放
                        moveOnMouseWheel: false, // 禁止滚轮平移
                        moveOnMouseMove: false,  // 禁止拖动
                        preventDefaultMouseMove: false,
                    },
                ],
                series: [
                    {
                        type: "line",
                        symbolSize: 0,
                        smooth: true, // 平滑曲线
                        areaStyle: {
                            opacity: 0.5,
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: this.colorS }, // 顶部颜色
                                    { offset: 1, color: this.colorS + '00' } // 底部渐变到透明
                                ]
                            },
                        },
                        lineStyle: {
                            width: 2,
                            color: this.colorS // 折线颜色
                        },
                        data: _data
                    }
                ],

            };

            this.chart.setOption(option);
        },

        resizeChart() {
            if (this.chart) {
                this.chart.resize();
            }
        },
    }
};
</script>

<style scoped>
.chart-container {
    width: 80px;
    height: 40px;
    /* 你可以在外部通过 CSS 改 */
}
</style>
